import React from 'react';
import classnames from 'classnames';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';

export interface Props {
  viewClassNames: {
    tab?: string;
    prefix?: string;
    label?: string;
    dropdown?: string;
    'active-tab': string;
  };
  label?: React.ReactNode;
  href?: string;
  prefix?: React.ReactNode;
  postfix?: React.ReactNode;
  dropdown?: React.ReactNode;
  biData?: BiEvent;
  isActive?: boolean;
  /** For BI automation */
  dataHook?: string;
  onClick?: (e: React.MouseEvent) => void;
  innerRef?: (node: HTMLElement | null) => void;
}

const Tab: React.FC<Props> = ({
  onClick,
  biData,
  dataHook,
  isActive,
  prefix,
  label,
  href,
  postfix,
  dropdown,
  viewClassNames: s,
  innerRef,
}) => {
  return (
    <PlainButtonOrLink
      className={classnames(s['tab'], isActive && s['active-tab'])}
      href={href}
      onClick={onClick}
      biData={biData}
      data-hook={dataHook}
      innerRef={innerRef}
      isFakeButton={!!dropdown}
    >
      {prefix && <div className={s['prefix']}>{prefix}</div>}
      <span className={s['label']}>{label}</span>
      {postfix}
      {dropdown && (
        <div className={s['dropdown']} onClick={ev => ev.stopPropagation()}>
          {dropdown}
        </div>
      )}
    </PlainButtonOrLink>
  );
};
Tab.displayName = 'Tab';

export default Tab;
